import { Link, Text } from '@chakra-ui/react';
import { FC } from 'react';
import Linkify from 'react-linkify';

import { IConversationMessage } from '@/utils/conversation/types';

interface INestedChatMessageBodyProps {
  message: IConversationMessage;
}

export const NestedChatMessageBody: FC<INestedChatMessageBodyProps> = ({ message }) => {
  return (
    <Text fontSize="sm" wordBreak="break-word" whiteSpace="pre-line">
      <Linkify
        componentDecorator={(href, text, key) => (
          <Link color="blue.500" href={href} key={key} target="_blank" rel="noopener noreferrer">
            {text}
          </Link>
        )}
      >
        {message.body}
      </Linkify>
    </Text>
  );
};
